// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.analytics-dashboard {
  padding: 1rem;
}

.dashboard-header {
  margin-bottom: 2rem;
  text-align: center;
}

.dashboard-header h2 {
  color: #333;
  margin-bottom: 1rem;
  font-size: 1.8rem;
}

.stats-summary {
  display: flex;
  justify-content: center;
  gap: 2rem;
  flex-wrap: wrap;
}

.stat-item {
  text-align: center;
  padding: 1rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 12px;
  min-width: 120px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.stat-number {
  display: block;
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.stat-label {
  font-size: 0.9rem;
  opacity: 0.9;
}

.dashboard-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 2rem;
}

.chart-section {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.chart-section.full-width {
  grid-column: 1 / -1;
}

.chart-container h3 {
  color: #333;
  margin-bottom: 1.5rem;
  font-size: 1.3rem;
  text-align: center;
}

/* Bar Chart */
.bar-chart {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.bar-item {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.bar-label {
  min-width: 120px;
  font-weight: 500;
  color: #555;
  font-size: 0.9rem;
}

.bar-wrapper {
  flex: 1 1;
  height: 30px;
  background: #f0f0f0;
  border-radius: 15px;
  overflow: hidden;
  position: relative;
}

.bar-fill {
  height: 100%;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 10px;
  transition: width 0.8s ease;
  position: relative;
}

.bar-value {
  color: white;
  padding-right: 10px;
  font-weight: bold;
  font-size: 0.8rem;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
}

/* Pie Chart Placeholder */
.pie-chart-placeholder {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.pie-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.8rem;
  background: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid transparent;
  transition: all 0.3s ease;
}

.pie-item:hover {
  background: #e9ecef;
  transform: translateX(5px);
}

.pie-color {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  flex-shrink: 0;
}

.pie-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1 1;
}

.pie-label {
  font-weight: 500;
  color: #333;
  font-size: 0.9rem;
}

.pie-value {
  background: #667eea;
  color: white;
  padding: 0.2rem 0.6rem;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: bold;
}

/* Method Grid */
.method-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
}

.method-card {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  color: white;
  padding: 1.5rem;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.method-card:hover {
  transform: translateY(-5px);
}

.method-icon {
  font-size: 2rem;
  margin-bottom: 0.5rem;
}

.method-name {
  font-weight: 600;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

.method-count {
  font-size: 1.5rem;
  font-weight: bold;
  opacity: 0.9;
}

/* Loading State */
.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  color: #666;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Responsive Design */
@media (max-width: 768px) {
  .dashboard-grid {
    grid-template-columns: 1fr;
  }
  
  .stats-summary {
    gap: 1rem;
  }
  
  .stat-item {
    min-width: 100px;
    padding: 0.8rem;
  }
  
  .stat-number {
    font-size: 1.5rem;
  }
  
  .bar-label {
    min-width: 80px;
    font-size: 0.8rem;
  }
  
  .method-grid {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  }
}

/* Animations */
.chart-section {
  animation: slideInUp 0.6s ease-out;
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.bar-fill {
  animation: growBar 1s ease-out;
}

@keyframes growBar {
  from {
    width: 0% !important;
  }
}

.method-card {
  animation: fadeInScale 0.5s ease-out;
}

@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* Dark theme for analytics */
.dark-theme .analytics-dashboard {
  color: #ffffff;
}

.dark-theme .dashboard-header h2 {
  color: #ffffff;
}

.dark-theme .chart-section {
  background: #2d2d2d;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.dark-theme .chart-container h3 {
  color: #ffffff;
}

.dark-theme .bar-label {
  color: #bdc3c7;
}

.dark-theme .bar-wrapper {
  background: #3d3d3d;
}

.dark-theme .pie-item {
  background: #3d3d3d;
  border-left-color: #667eea;
}

.dark-theme .pie-item:hover {
  background: #4d4d4d;
}

.dark-theme .pie-label {
  color: #ffffff;
}

.dark-theme .method-card {
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
}

.data-section {
  margin-top: 2rem;
  grid-column: 1 / -1;
}

.table-container {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  overflow: hidden;
}

.table-header {
  padding: 1.5rem;
  border-bottom: 1px solid #e1e5e9;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.table-header h3 {
  margin: 0;
  color: #333;
  font-size: 1.3rem;
}

.table-stats {
  display: flex;
  gap: 1rem;
}

.table-stats .stat {
  background: #f8f9fa;
  padding: 0.4rem 0.8rem;
  border-radius: 6px;
  font-size: 0.9rem;
  color: #666;
}

.table-wrapper {
  overflow-x: auto;
  max-height: 500px;
  overflow-y: auto;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
}

.data-table th {
  background: #f8f9fa;
  padding: 0.8rem;
  text-align: left;
  font-weight: 600;
  color: #333;
  border-bottom: 2px solid #e1e5e9;
  position: sticky;
  top: 0;
  z-index: 10;
}

.data-table td {
  padding: 0.6rem 0.8rem;
  border-bottom: 1px solid #f0f0f0;
  color: #444;
}

.data-table tr:hover {
  background: #f8f9fa;
}

.data-table .even-row {
  background: #fafbfc;
}

.data-table .odd-row {
  background: #fff;
}

.data-table .cell-0 {
  font-weight: 500;
  color: #2193b0;
}

.data-table .cell-1 {
  color: #333;
}

.data-table .cell-2 {
  color: #666;
}

@media (max-width: 768px) {
  .table-header {
    flex-direction: column;
    gap: 1rem;
    align-items: flex-start;
  }
  
  .table-stats {
    width: 100%;
    justify-content: space-between;
  }
  
  .data-table {
    font-size: 0.8rem;
  }
  
  .data-table th,
  .data-table td {
    padding: 0.5rem 0.4rem;
  }
} 

/* Chart Container - делаем кликабельным */
.chart-container {
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.chart-container:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.chart-container::before {
  content: '';
  position: absolute;
  top: 10px;
  right: 10px;
  width: 20px;
  height: 20px;
  background: rgba(102, 126, 234, 0.1);
  border-radius: 50%;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.chart-container:hover::before {
  opacity: 1;
}

.chart-container::after {
  content: '🔍';
  position: absolute;
  top: 8px;
  right: 8px;
  font-size: 14px;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.chart-container:hover::after {
  opacity: 1;
}

/* Модальное окно */
.chart-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
  animation: fadeIn 0.3s ease;
}

.chart-modal {
  background: white;
  border-radius: 16px;
  max-width: 90vw;
  max-height: 90vh;
  width: 800px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: slideInScale 0.3s ease;
  overflow: hidden;
}

.chart-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem;
  border-bottom: 1px solid #e0e0e0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.chart-modal-header h3 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
}

.chart-modal-close {
  background: none;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.chart-modal-close:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: scale(1.1);
}

.chart-modal-content {
  padding: 2rem;
  max-height: calc(90vh - 100px);
  overflow-y: auto;
}

/* Анимации */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideInScale {
  from {
    opacity: 0;
    transform: scale(0.8) translateY(20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

/* Темная тема для модального окна */
.dark-theme .chart-modal {
  background: #1a1a1a;
  color: #ffffff;
}

.dark-theme .chart-modal-header {
  background: linear-gradient(135deg, #1e3a8a 0%, #3bbedb 100%);
  border-bottom: 1px solid #333;
}

.dark-theme .chart-modal-content {
  background: #1a1a1a;
}

/* Адаптивность для мобильных устройств */
@media (max-width: 768px) {
  .chart-modal {
    width: 95vw;
    max-height: 95vh;
    margin: 1rem;
  }
  
  .chart-modal-header {
    padding: 1rem 1.5rem;
  }
  
  .chart-modal-header h3 {
    font-size: 1.2rem;
  }
  
  .chart-modal-content {
    padding: 1.5rem;
  }
  
  .chart-container::before,
  .chart-container::after {
    display: none;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/analytics/AnalyticsDashboard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,6DAA6D;EAC7D,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,2DAA2D;EAC7D;AACF;;AAEA,eAAe;AACf;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,6BAA6B;AAC7B;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,gCAAgC;EAChC,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,sBAAsB;EACxB;AACF;;AAEA,0CAA0C;AAC1C;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,0CAA0C;EAC1C,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,oCAAoC;AACpC;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yCAAyC;AACzC;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,aAAa;EACf;AACF","sourcesContent":[".analytics-dashboard {\r\n  padding: 1rem;\r\n}\r\n\r\n.dashboard-header {\r\n  margin-bottom: 2rem;\r\n  text-align: center;\r\n}\r\n\r\n.dashboard-header h2 {\r\n  color: #333;\r\n  margin-bottom: 1rem;\r\n  font-size: 1.8rem;\r\n}\r\n\r\n.stats-summary {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 2rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.stat-item {\r\n  text-align: center;\r\n  padding: 1rem;\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  color: white;\r\n  border-radius: 12px;\r\n  min-width: 120px;\r\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.stat-number {\r\n  display: block;\r\n  font-size: 2rem;\r\n  font-weight: bold;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.stat-label {\r\n  font-size: 0.9rem;\r\n  opacity: 0.9;\r\n}\r\n\r\n.dashboard-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));\r\n  gap: 2rem;\r\n}\r\n\r\n.chart-section {\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 1.5rem;\r\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.chart-section.full-width {\r\n  grid-column: 1 / -1;\r\n}\r\n\r\n.chart-container h3 {\r\n  color: #333;\r\n  margin-bottom: 1.5rem;\r\n  font-size: 1.3rem;\r\n  text-align: center;\r\n}\r\n\r\n/* Bar Chart */\r\n.bar-chart {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1rem;\r\n}\r\n\r\n.bar-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n}\r\n\r\n.bar-label {\r\n  min-width: 120px;\r\n  font-weight: 500;\r\n  color: #555;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.bar-wrapper {\r\n  flex: 1;\r\n  height: 30px;\r\n  background: #f0f0f0;\r\n  border-radius: 15px;\r\n  overflow: hidden;\r\n  position: relative;\r\n}\r\n\r\n.bar-fill {\r\n  height: 100%;\r\n  border-radius: 15px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  padding-right: 10px;\r\n  transition: width 0.8s ease;\r\n  position: relative;\r\n}\r\n\r\n.bar-value {\r\n  color: white;\r\n  padding-right: 10px;\r\n  font-weight: bold;\r\n  font-size: 0.8rem;\r\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n/* Pie Chart Placeholder */\r\n.pie-chart-placeholder {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.8rem;\r\n}\r\n\r\n.pie-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  padding: 0.8rem;\r\n  background: #f8f9fa;\r\n  border-radius: 8px;\r\n  border-left: 4px solid transparent;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.pie-item:hover {\r\n  background: #e9ecef;\r\n  transform: translateX(5px);\r\n}\r\n\r\n.pie-color {\r\n  width: 20px;\r\n  height: 20px;\r\n  border-radius: 50%;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.pie-info {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  flex: 1;\r\n}\r\n\r\n.pie-label {\r\n  font-weight: 500;\r\n  color: #333;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.pie-value {\r\n  background: #667eea;\r\n  color: white;\r\n  padding: 0.2rem 0.6rem;\r\n  border-radius: 12px;\r\n  font-size: 0.8rem;\r\n  font-weight: bold;\r\n}\r\n\r\n/* Method Grid */\r\n.method-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\r\n  gap: 1rem;\r\n}\r\n\r\n.method-card {\r\n  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);\r\n  color: white;\r\n  padding: 1.5rem;\r\n  border-radius: 12px;\r\n  text-align: center;\r\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n.method-card:hover {\r\n  transform: translateY(-5px);\r\n}\r\n\r\n.method-icon {\r\n  font-size: 2rem;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.method-name {\r\n  font-weight: 600;\r\n  margin-bottom: 0.5rem;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.method-count {\r\n  font-size: 1.5rem;\r\n  font-weight: bold;\r\n  opacity: 0.9;\r\n}\r\n\r\n/* Loading State */\r\n.loading-state {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 3rem;\r\n  color: #666;\r\n}\r\n\r\n.loading-spinner {\r\n  width: 40px;\r\n  height: 40px;\r\n  border: 4px solid #f3f3f3;\r\n  border-top: 4px solid #667eea;\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n@keyframes spin {\r\n  0% { transform: rotate(0deg); }\r\n  100% { transform: rotate(360deg); }\r\n}\r\n\r\n/* Responsive Design */\r\n@media (max-width: 768px) {\r\n  .dashboard-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  \r\n  .stats-summary {\r\n    gap: 1rem;\r\n  }\r\n  \r\n  .stat-item {\r\n    min-width: 100px;\r\n    padding: 0.8rem;\r\n  }\r\n  \r\n  .stat-number {\r\n    font-size: 1.5rem;\r\n  }\r\n  \r\n  .bar-label {\r\n    min-width: 80px;\r\n    font-size: 0.8rem;\r\n  }\r\n  \r\n  .method-grid {\r\n    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\r\n  }\r\n}\r\n\r\n/* Animations */\r\n.chart-section {\r\n  animation: slideInUp 0.6s ease-out;\r\n}\r\n\r\n@keyframes slideInUp {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(30px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n.bar-fill {\r\n  animation: growBar 1s ease-out;\r\n}\r\n\r\n@keyframes growBar {\r\n  from {\r\n    width: 0% !important;\r\n  }\r\n}\r\n\r\n.method-card {\r\n  animation: fadeInScale 0.5s ease-out;\r\n}\r\n\r\n@keyframes fadeInScale {\r\n  from {\r\n    opacity: 0;\r\n    transform: scale(0.8);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n  }\r\n}\r\n\r\n/* Dark theme for analytics */\r\n.dark-theme .analytics-dashboard {\r\n  color: #ffffff;\r\n}\r\n\r\n.dark-theme .dashboard-header h2 {\r\n  color: #ffffff;\r\n}\r\n\r\n.dark-theme .chart-section {\r\n  background: #2d2d2d;\r\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.dark-theme .chart-container h3 {\r\n  color: #ffffff;\r\n}\r\n\r\n.dark-theme .bar-label {\r\n  color: #bdc3c7;\r\n}\r\n\r\n.dark-theme .bar-wrapper {\r\n  background: #3d3d3d;\r\n}\r\n\r\n.dark-theme .pie-item {\r\n  background: #3d3d3d;\r\n  border-left-color: #667eea;\r\n}\r\n\r\n.dark-theme .pie-item:hover {\r\n  background: #4d4d4d;\r\n}\r\n\r\n.dark-theme .pie-label {\r\n  color: #ffffff;\r\n}\r\n\r\n.dark-theme .method-card {\r\n  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);\r\n}\r\n\r\n.data-section {\r\n  margin-top: 2rem;\r\n  grid-column: 1 / -1;\r\n}\r\n\r\n.table-container {\r\n  background: #fff;\r\n  border-radius: 12px;\r\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\r\n  overflow: hidden;\r\n}\r\n\r\n.table-header {\r\n  padding: 1.5rem;\r\n  border-bottom: 1px solid #e1e5e9;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.table-header h3 {\r\n  margin: 0;\r\n  color: #333;\r\n  font-size: 1.3rem;\r\n}\r\n\r\n.table-stats {\r\n  display: flex;\r\n  gap: 1rem;\r\n}\r\n\r\n.table-stats .stat {\r\n  background: #f8f9fa;\r\n  padding: 0.4rem 0.8rem;\r\n  border-radius: 6px;\r\n  font-size: 0.9rem;\r\n  color: #666;\r\n}\r\n\r\n.table-wrapper {\r\n  overflow-x: auto;\r\n  max-height: 500px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.data-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.data-table th {\r\n  background: #f8f9fa;\r\n  padding: 0.8rem;\r\n  text-align: left;\r\n  font-weight: 600;\r\n  color: #333;\r\n  border-bottom: 2px solid #e1e5e9;\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 10;\r\n}\r\n\r\n.data-table td {\r\n  padding: 0.6rem 0.8rem;\r\n  border-bottom: 1px solid #f0f0f0;\r\n  color: #444;\r\n}\r\n\r\n.data-table tr:hover {\r\n  background: #f8f9fa;\r\n}\r\n\r\n.data-table .even-row {\r\n  background: #fafbfc;\r\n}\r\n\r\n.data-table .odd-row {\r\n  background: #fff;\r\n}\r\n\r\n.data-table .cell-0 {\r\n  font-weight: 500;\r\n  color: #2193b0;\r\n}\r\n\r\n.data-table .cell-1 {\r\n  color: #333;\r\n}\r\n\r\n.data-table .cell-2 {\r\n  color: #666;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .table-header {\r\n    flex-direction: column;\r\n    gap: 1rem;\r\n    align-items: flex-start;\r\n  }\r\n  \r\n  .table-stats {\r\n    width: 100%;\r\n    justify-content: space-between;\r\n  }\r\n  \r\n  .data-table {\r\n    font-size: 0.8rem;\r\n  }\r\n  \r\n  .data-table th,\r\n  .data-table td {\r\n    padding: 0.5rem 0.4rem;\r\n  }\r\n} \r\n\r\n/* Chart Container - делаем кликабельным */\r\n.chart-container {\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.chart-container:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.chart-container::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 10px;\r\n  width: 20px;\r\n  height: 20px;\r\n  background: rgba(102, 126, 234, 0.1);\r\n  border-radius: 50%;\r\n  opacity: 0;\r\n  transition: opacity 0.3s ease;\r\n}\r\n\r\n.chart-container:hover::before {\r\n  opacity: 1;\r\n}\r\n\r\n.chart-container::after {\r\n  content: '🔍';\r\n  position: absolute;\r\n  top: 8px;\r\n  right: 8px;\r\n  font-size: 14px;\r\n  opacity: 0;\r\n  transition: opacity 0.3s ease;\r\n}\r\n\r\n.chart-container:hover::after {\r\n  opacity: 1;\r\n}\r\n\r\n/* Модальное окно */\r\n.chart-modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.7);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n  backdrop-filter: blur(5px);\r\n  animation: fadeIn 0.3s ease;\r\n}\r\n\r\n.chart-modal {\r\n  background: white;\r\n  border-radius: 16px;\r\n  max-width: 90vw;\r\n  max-height: 90vh;\r\n  width: 800px;\r\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\r\n  animation: slideInScale 0.3s ease;\r\n  overflow: hidden;\r\n}\r\n\r\n.chart-modal-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 1.5rem 2rem;\r\n  border-bottom: 1px solid #e0e0e0;\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  color: white;\r\n}\r\n\r\n.chart-modal-header h3 {\r\n  margin: 0;\r\n  font-size: 1.5rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.chart-modal-close {\r\n  background: none;\r\n  border: none;\r\n  color: white;\r\n  font-size: 1.5rem;\r\n  cursor: pointer;\r\n  padding: 0.5rem;\r\n  border-radius: 50%;\r\n  width: 40px;\r\n  height: 40px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.chart-modal-close:hover {\r\n  background: rgba(255, 255, 255, 0.2);\r\n  transform: scale(1.1);\r\n}\r\n\r\n.chart-modal-content {\r\n  padding: 2rem;\r\n  max-height: calc(90vh - 100px);\r\n  overflow-y: auto;\r\n}\r\n\r\n/* Анимации */\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes slideInScale {\r\n  from {\r\n    opacity: 0;\r\n    transform: scale(0.8) translateY(20px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: scale(1) translateY(0);\r\n  }\r\n}\r\n\r\n/* Темная тема для модального окна */\r\n.dark-theme .chart-modal {\r\n  background: #1a1a1a;\r\n  color: #ffffff;\r\n}\r\n\r\n.dark-theme .chart-modal-header {\r\n  background: linear-gradient(135deg, #1e3a8a 0%, #3bbedb 100%);\r\n  border-bottom: 1px solid #333;\r\n}\r\n\r\n.dark-theme .chart-modal-content {\r\n  background: #1a1a1a;\r\n}\r\n\r\n/* Адаптивность для мобильных устройств */\r\n@media (max-width: 768px) {\r\n  .chart-modal {\r\n    width: 95vw;\r\n    max-height: 95vh;\r\n    margin: 1rem;\r\n  }\r\n  \r\n  .chart-modal-header {\r\n    padding: 1rem 1.5rem;\r\n  }\r\n  \r\n  .chart-modal-header h3 {\r\n    font-size: 1.2rem;\r\n  }\r\n  \r\n  .chart-modal-content {\r\n    padding: 1.5rem;\r\n  }\r\n  \r\n  .chart-container::before,\r\n  .chart-container::after {\r\n    display: none;\r\n  }\r\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
